module.exports = __webpack_public_path__ + "static/media/ice7.6cd2ec3e.webp";